exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/assignment-submission.js-WebpackMultiOutput";